<div class="container-fluid customers-root">
  <app-card-analytics [stats]="stats"></app-card-analytics>

  <div class="table-root">
    <div class="table-action-wrapper d-flex align-items-center justify-content-between">
      <div class="search-input">
        <img src="../../assets/icons/search.svg" alt="Search icon" (click)="search()" />
        <input type="text" [placeholder]="'COMMON.SEARCH' | translate" [(ngModel)]="searchText" (keydown.enter)="search()" 
        (ngModelChange)="this.searchTextUpdate.next($event)" />
      </div>

      <div class="ml-auto d-flex">
        <div>
          <div class="d-flex">

            <div class="datetype-picker">
              <div class="dropdown date-type-dropdown" (click)="showSelectDateType = !showSelectDateType"
                click-stop-propagation  [title]="selectedDateTypeDisplay | translate">
                <span>{{'COMMON.DATE_TYPE.TITLE' | translate}}:</span>
                <span>{{ selectedDateTypeDisplay | translate }}</span>
                <span class="arrow"><img src="../../assets/icons/gray-arrow-down.svg" alt="Gray arrow down" /></span>
              </div>
              <div class="dropdown-opened" *ngIf="showSelectDateType">
                <div (click)="selectDateType(dateType); (datesValid() == true && (dateTo || dateFrom)) && search()
                  " *ngFor="let dateType of dateTypes; let i = index">
                  <div>{{ dateType.translation | translate }}</div>
                </div>
              </div>
            </div>

            <div class="datepicker-container" style="width: 23rem;">
              <label for="dateFrom"> {{'COMMON.FROM' | translate}}: </label>
              <input type="date" name="dateFrom" [ngClass]="
                  dateFrom > dateTo
                    ? 'btn datepicker-icon-error'
                    : 'btn datepicker-icon'
                " [(ngModel)]="dateFrom" (change)="datesValid() == true && search()" />
            </div>

            <div class="datepicker-container">
              <label for="dateTo" class="right-label"> {{'COMMON.TO' | translate}}: </label>
              <input type="date" name="dateTo" [ngClass]="
                  dateFrom > dateTo
                    ? 'btn datepicker-icon-error'
                    : 'btn datepicker-icon'
                " [(ngModel)]="dateTo" (change)="datesValid() == true && search()" />
            </div>

            <div class="sort-by-root" (click)="showSortBy = !showSortBy" click-stop-propagation>
              <div class="dropdown" [title]="sortByName | translate">
                <span>{{'COMMON.SORT_BY.TITLE' | translate}}:</span>
                <span>{{ sortByName | translate }}</span>
                <span><img src="../../assets/icons/gray-arrow-down.svg" alt="Gray arrow down" /></span>
              </div>
              <div class="dropdown-opened" *ngIf="showSortBy">
                <div (click)="sortByMethod(sortByOptions.NEWEST)">{{'COMMON.SORT_BY.NEWEST' | translate}}</div>
                <div (click)="sortByMethod(sortByOptions.SLRN_ASC)">{{'COMMON.SORT_BY.SLRN_ASC' | translate}}.</div>
                <div (click)="sortByMethod(sortByOptions.SLRN_DESC)">{{'COMMON.SORT_BY.SLRN_DESC' | translate}}.</div>
                <div (click)="sortByMethod(sortByOptions.ID_ASC)">{{'COMMON.SORT_BY.ID_ASC' | translate}}.</div>
                <div (click)="sortByMethod(sortByOptions.ID_DESC)">{{'COMMON.SORT_BY.ID_DESC' | translate}}.</div>
              </div>
            </div>

            <button *ngIf="permissionsService.isMVPoleDownloadAllowed" class="btn btn-icon" (click)="download()">
                <span>{{'COMMON.DOWNLOAD' | translate}}</span>
            </button>

            <div *ngIf="permissionsService.isMVPoleCreateEditAllowed">
              <button class="btn btn-primary btn-upload" (click)="showUpload = !showUpload" click-stop-propagation>
                <img src="../../assets/icons/chevron-down.svg" alt="Chevron down" />
              </button>
              <div *ngIf="showUpload" class="xlsx-upload">
                <div><img src="../../assets/icons/upload-arrow.svg" alt="Upload icon" /></div>
                <div>{{'COMMON.UPLOAD_XLSX' | translate}}</div>
              </div>
            </div>
            <button class="btn btn-primary btn-add-new" *ngIf="permissionsService.isMVPoleCreateEditAllowed">
                <img src="../../assets/icons/plus.svg" alt="Plus icon" />
                <span style="white-space: nowrap;">{{'MV_POLES.NEW' | translate}}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="filter">
      <div class="filter-list">
        {{'COMMON.FILTER' | translate}}
        <app-multi-select-dropdown class="multiselect" [clicked]="clicked"
          [items]="hasCimDataIntegration ? geographicalRegions : regions" [label]="'COMMON.BU.PLURAL'"
          [showMore]="false" [requireApply]="true"
          (shareIndividualCheckedList)="hasCimDataIntegration ? selectGeographicalRegion($event) : selectRegion($event)">
        </app-multi-select-dropdown>

        <app-multi-select-dropdown class="multiselect" [clicked]="clicked"
          [items]="hasCimDataIntegration ? subGeographicalRegions : areas" [label]="'COMMON.UT.PLURAL'"
          [showMore]="false" [requireApply]="true" (shareIndividualCheckedList)="selectArea($event)">
        </app-multi-select-dropdown>

        <select name="st-select" (change)="selectUserType($event)" class="form-select">
          <option value="" [selected]="!userType" disabled>
            {{'COMMON.USER.TYPE.TITLE' | translate}}
          </option>
          <option [selected]="userType == o.value" *ngFor="let o of userTypeOptions; let i = index" value="{{ o.value }}">
            {{ o.translation | translate }}
          </option>
        </select>

        <app-multi-select-dropdown class="multiselect" [searchFilterActive]="true"
          (filterValue)="applySearchFilter($event)" [clicked]="clicked" [items]="filteredUsers" [label]="'COMMON.USER.PLURAL'"
          [showMore]="false" [requireApply]="true" (shareIndividualCheckedList)="selectUsers($event)">
        </app-multi-select-dropdown>

        <select name="pole-type" (change)="selectPoleType($event)" class="form-select">
          <option value="0" [selected]="poleType == 0" disabled>{{'COMMON.TABLE_HEADERS.POLE_TYPE' | translate}}</option>
          <option [selected]="poleType == o.key" *ngFor="let o of poleTypesOptions; let i = index" value="{{ o.key }}">
            {{ o.value | translate }}
          </option>
        </select>
        
        <app-multi-select-dropdown class="multiselect" *ngIf="permissionsService.isValidationStatusAllowed" [clicked]="clicked" [items]="poleStatusOptions" [label]="'COMMON.VALIDATION_STATUS'"
          [showMore]="false" [requireApply]="true" (shareIndividualCheckedList)="selectPoleStatus($event)">
        </app-multi-select-dropdown>
      </div>

      <div *ngIf="selectedFilters.length > 0">
        <app-filter-checklist [filters]="selectedFilters" (resetFilterEmitter)="resetFilter($event)" [useApply]="true"
          (applyFilterEmitter)="applyFilter()" (removeFilterEmitter)="removeFilter($event)">
        </app-filter-checklist>
      </div>

    </div>
    <div class="table">
      <div *ngIf="mvPoles">
        <table class="table border-bottom">
          <thead class="table-light">
            <tr>
            <th class="th-checkbox">
                <input type="checkbox" class="form-check-input" [ngModel]="allCheckboxesChecked"
                  (click)="checkAllCheckboxes()" />
            </th>
            <th>{{'MV_POLES.SINGLE' | translate}} SLRN</th>
            <th>{{'MV_POLES.SINGLE' | translate}} ID</th>
            <th>{{'MV_POLES.SINGLE' | translate}} NO</th>
            <th>{{"COMMON.TABLE_HEADERS.POLE_TYPE" | translate}}</th>
            <th>{{'TRANSFORMERS.EDIT.11KV_FEEDER_NAME' | translate}}</th>
            <th>{{'MV_POLES.SINGLE' | translate}} {{'COMMON.ADDRESS' | translate}}</th>
            <th>{{"COMMON.UT.SINGLE" | translate}}</th>
            <th>{{"COMMON.BU.SINGLE" | translate}}</th>
            <th *ngIf="permissionsService.isValidationStatusAllowed">{{"COMMON.VALIDATION_STATUS" | translate}}</th>
            <th></th>
            </tr>
          </thead>
          <tbody>
                <tr *ngFor="let mvPole of mvPoles">
                <td type="checkbox">
                      <input type="checkbox" class="form-check-input" value="{{ mvPole.id }}" [ngModel]="mvPole.isChecked"
                  (click)="checkPole(mvPole.id)" />
                </td>
                <td [routerLink]="['edit', mvPole.id]" (click)="setFilterStorage()">
                  {{mvPole.slrn}}
                </td> 
                <td [routerLink]="['edit', mvPole.id]" (click)="setFilterStorage()" class="centered">
                  {{mvPole.poleId}}
                </td>
                <td [routerLink]="['edit', mvPole.id]" (click)="setFilterStorage()">
                  {{mvPole.poleNumber}}
                </td>
                <td [routerLink]="['edit', mvPole.id]" (click)="setFilterStorage()">
                  {{'COMMON.POLE.TYPE.'+ mvPole.poleType.toString().toUpperCase() | translate }}
                </td>
                <td [routerLink]="['edit', mvPole.id]" (click)="setFilterStorage()">
                  {{hasCimDataIntegration ? mvPole.acLineName : mvPole.feeder11Name}}
                </td>
                <td [routerLink]="['edit', mvPole.id]" (click)="setFilterStorage()">
                  {{mvPole.address}}
                </td>
                <td [routerLink]="['edit', mvPole.id]" (click)="setFilterStorage()">
                  {{hasCimDataIntegration ? mvPole.subGeographicalRegionName : mvPole.area}}
                </td>
                <td [routerLink]="['edit', mvPole.id]" (click)="setFilterStorage()">
                  {{hasCimDataIntegration ? mvPole.geographicalRegionName : mvPole.region}}
                </td>
                <td *ngIf="permissionsService.isValidationStatusAllowed" [routerLink]="['edit', mvPole.id]" (click)="setFilterStorage()">
                    <span class="status" [ngClass]="{
                    'complete-building': mvPole.status == 'Complete',
                    'pending-building': mvPole.status == 'Pending',
                    'assigned-building': mvPole.status == 'Assigned' || mvPole.status == 'Retagged',
                    'rejected-building': mvPole.status == 'Rejected'
                    }">{{ 'COMMON.ASSET_STATUS.'+ mvPole.status.toString().toUpperCase() | translate }}</span>
                </td>
                <td class="more-icon" (click)="setFilterStorage()" [routerLink]="['edit', mvPole.id]">
                  <img src="../../assets/icons/more-icon.svg" alt="More icon" class="more-icon" />
                </td>
                </tr>
            </tbody>
        </table>
        <div>
          <app-paging *ngIf="count > 0" [pageSize]="pageSize" [useDirect]="true" [count]="count"
            [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-paging>
        </div>
      </div>
    </div>
  </div>
</div>